import { useTranslation } from "react-i18next";

import { getRefreshBucketStart, HaNContext, useAreaConnections } from "@lib/logic";
import { timeLabel } from "@lib/store/src/data/timeslots/dateTimeHelpers";
import { useRequiredContext } from "@lib/utils";
import { UserCell } from "@molecules";

// The connections who booked a place in the area today, and when
export const AreaConnections = ({ areaId }: { areaId: string }) => {
  const { t } = useTranslation();
  const { bucket } = useRequiredContext(HaNContext);
  const connections = useAreaConnections({ areaId, now: new Date(getRefreshBucketStart(bucket)) });

  if (connections.length === 0) return null;

  return (
    <section className="flex flex-col gap-4">
      <h3 className="text-[20px] font-semibold leading-[25px]">{t("connection:ConnectionsThatBookedHere")}</h3>

      {connections.map(({ user, reservation }) => (
        <UserCell
          key={reservation.id}
          user={user}
          subtitle={timeLabel(reservation.localStart, reservation.localEnd, t)}
          padding="none"
          separator={false}
          shouldShowCheckIn
        />
      ))}
    </section>
  );
};
